import React, { ReactNode } from "react";

import {
  ApiTwoTone,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleTwoTone,
  InfoCircleTwoTone,
  LoadingOutlined,
  PlusCircleOutlined,
  WarningTwoTone,
} from "@ant-design/icons";

import { Colors } from "../colors";
import { TextIcon } from "./text-icon";

export type IconType =
  | "Add New"
  | "Loading"
  | "Information"
  | "Warning"
  | "Error"
  | "Delete"
  | "Edit"
  | "Close"
  | "Text"
  | "Import";

export const Icons: Record<IconType, ReactNode> = {
  "Add New": <PlusCircleOutlined />,
  Loading: <LoadingOutlined />,
  Information: <InfoCircleTwoTone twoToneColor={Colors.Primary} />,
  Warning: <WarningTwoTone twoToneColor={Colors.Warning} />,
  Error: <ExclamationCircleTwoTone twoToneColor={Colors.Error} />,
  Delete: <DeleteOutlined />,
  Edit: <EditOutlined />,
  Close: <CloseOutlined />,
  Text: (
    <TextIcon
      style={{
        left: -1,
        top: 1,
        marginRight: 5,
        position: "relative",
        lineHeight: "inherit",
        verticalAlign: "middle",
        color: Colors.Primary,
      }}
    />
  ),
  Import: <ApiTwoTone twoToneColor={Colors.Primary} />,
};
